import React from "react";

import "./mobilePlaySpots.css";

import BG_BANNER from "../../assets/img/pspot-bg.jpg";
import PSPOT_1 from "../../assets/img/psopt-1.png";
import PSPOT_2 from "../../assets/img/psopt-2.png";
import APPSTORE from "../../assets/img/appstore.jpg";
import PLAYSTORE from "../../assets/img/googleplay.jpg";
import PSOPT_LOGO from "../../assets/img/logo-og.png";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link } from "react-router-dom";
import { WHITE } from "../../utilities/colors";

const MobilePlaySpots = () => {

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mobilePlaySpots">
      <div className="mobilePlaySpots-wrapper">
        <div className="mobilePlaySpots-top-nav">
          <div className="col-1">
            <div className="mobilePlaySpots-goBack">
              <div className="arrow">
                <Link to="/">
                  <ArrowBackIosIcon
                    style={{ color: WHITE }}
                    className="icon"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-10 d-flex justify-content-center align-items-center">
            <div className="mobilePlaySpots-logo">
              <img src={PSOPT_LOGO} alt="" />
            </div>
          </div>
          <div className="col-1"></div>
        </div>
        <div className="mobilePlaySpots-topSection">
          <div className="mobilePlaySpots-top-banner">
            <img src={BG_BANNER} alt="" />
          </div>
          <div className="mobilePlaySpots-top-imgWrapper">
            <div className="mobilePlaySpots-top-img">
              <img src={PSPOT_1} alt="" />
            </div>
          </div>
        </div>
        <div className="container">
          <div className="mobilePlaySpots-middleSection">
            <div className="mobilePlaySpots-content-wrapper">
              <h4>SEARCH | FIND | BOOK</h4>
              <h4>PLAY & ENJOY</h4>
              <p>Find & Book your sports facilities with PlaySpots</p>
              <p>Bring your sporting life with you wherever you are.....</p>
            </div>
            <div className="mobilePlaySpots-middle-img">
              <img src={PSPOT_2} alt="" />
            </div>
            <div className="mobilePlaySpots-content-wrapper">
              <p>
                PlaySpots is a sport facility booking and community building
                platform which aims to connect sports facilities to the
                sportaholics.
              </p>
            </div>
          </div>
          <div className="mobilePlaySpots-bottomSection">
            <div className="mobilePlaySpots-social-wrapper">
              <div className="mobilePlaySpots-social-img">
                <a href="https://play.google.com/store/apps/details?id=app.playspots.lite&hl=en_IN" target="_blank">
                  <img src={PLAYSTORE} alt="" />
                </a>
              </div>
              <div className="mobilePlaySpots-social-img">
                <a href="https://apps.apple.com/in/app/playspots-lite/id6711351799" target="_blank">
                  <img src={APPSTORE} alt="" />
                </a>
              </div>
            </div>
            <div className="mobilePlaySpots-visit-btn">
              <a href="https://www.playspots.in/" target="_blank">
                <button>VISIT WEBSITE</button>
              </a>
              <a href="https://www.instagram.com/playspotsapp/" target="_blank">
                <button className="insta">VISIT INSTAGRAM</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobilePlaySpots;
